import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const SectionBlock = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
  background-color: var(--white);
  border: 1px solid rgba(0, 0, 0, 0.04);
  border-radius: 16px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);
  padding: 28px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 18px 14px;
    border-radius: 12px;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
  }
`;

export const SectionTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SectionTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: var(--dark-gray);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    color: var(--fixit);
  }
`;

export const SectionSubtitle = styled.p`
  font-size: 13px;
  color: var(--gray);
  margin: 0;
  line-height: 1.4;
`;

/* --- PILL SWITCH FROM customers/edit/ --- */

export const PersonTypeSwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
`;

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 4px;
  width: fit-content;

  @media (max-width: 768px) {
    width: 100%;

    button {
      flex: 1;
      text-align: center;
      padding: 8px 12px;
    }
  }
`;

export const SwitchOption = styled.button<{ selected: boolean }>`
  border: none;
  background-color: ${({ selected }) =>
    selected ? "var(--white)" : "transparent"};
  color: ${({ selected }) =>
    selected ? "var(--fixit)" : "var(--dark-gray)"};
  font-weight: ${({ selected }) => (selected ? "600" : "400")};
  padding: 6px 16px;
  border-radius: 6px;
  cursor: pointer;
  box-shadow: ${({ selected }) =>
    selected ? "0px 2px 4px rgba(0, 0, 0, 0.05)" : "none"};
  transition: all 0.2s;
  font-size: 14px;
`;

/* --- INPUTS & GRID --- */

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const FlexInput = styled.div<{ flex?: number }>`
  flex: ${({ flex }) => flex || 1};
  display: flex;
  flex-direction: column;
`;

/* --- FOOTER & ACTION BUTTONS --- */

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 12px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 14px;
    
    button {
      width: 100%;
    }
  }
`;

export const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: var(--white);
  color: var(--gray);
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  height: 44px;

  &:hover {
    background-color: #f7f7f7;
    color: var(--dark-gray);
    border-color: #ccc;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

/* Compatibilidade com versões anteriores */
export const ProfileSelector = PersonTypeSwitchWrapper;
export const ProfileCard = styled.div<{ active: boolean }>``;
